import React from 'react';
import { Switch, Route, NavLink, useHistory, Redirect, Link } from 'react-router-dom';
import BarChart from './charts/BarChart';
import { Col, Row } from 'antd';

import { Spin, Tooltip, Badge, Rate, Select, Popover, Modal, Layout, Menu, Button, Popconfirm, Input } from 'antd';
import {
    RiseOutlined, FileExcelOutlined, ScheduleOutlined, ProfileOutlined, LoadingOutlined, SearchOutlined, HomeOutlined, AlertOutlined, DollarCircleOutlined, InfoCircleOutlined, CreditCardOutlined, FireOutlined, ToolOutlined, TagOutlined, CarOutlined, BarChartOutlined, AppstoreOutlined, LineChartOutlined, TableOutlined, LeftOutlined, RightOutlined, UserOutlined, SettingOutlined
    , EditOutlined
} from '@ant-design/icons';

import YearStatistics from './YearStatistics';
import MonthStatistics from './MonthStatistics';
import DayStatistics from './DayStatistics';


const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const charts = () => {
    return (
        <Layout style={{ height: '100vh' }}>

            <Sider width={50} style={{ height: '100vh', width: 50, background: "black" }}>
                <div style={{ display: "flex", flexFlow: "column", height: "99vh" }}>
                    <div style={{ height: '90vh', marginTop: 8 }}>

                        <Popover content={'Resumen Ejecutivo | Grupo Óptima'} trigger="hover" placement="left">
                            <Button style={{ fontSize: 16 }} className={"m-color-white"} size="large" type="link">
                                <Link to="/main/resumenEjecutivoGO"><HomeOutlined /> </Link>
                            </Button>
                        </Popover>
                        <Popover content={'Resumen Gerencial'} trigger="hover" placement="left">
                            <Button style={{ fontSize: 16 }} className={"m-color-white"} size="large" type="link">
                                <Link to="/main/resumenGerencial"><ProfileOutlined /> </Link>
                            </Button>
                        </Popover>

                        <Popover content={'Métricos'} trigger="hover" placement="left">
                            <Button style={{ fontSize: 16 }} className={"m-color-white"} size="large" type="link">
                                <Link to="/main/metrix"><RiseOutlined /> </Link>
                            </Button>
                        </Popover>

                        <Popover content={'Reportes'} trigger="hover" placement="left">
                            <Badge count={0} offset={[-10, 8]} style={{ backgroundColor: '#FF952B' }}>
                                <Button style={{ fontSize: 16 }} className={"m-color-white"} size="large" type="link">
                                    <Link to="/main/reports"> <FileExcelOutlined /></Link>
                                </Button>
                            </Badge>
                        </Popover>


                        <Popover content={'Evaluacion optima'} trigger="hover" placement="left">
                            <Button style={{ fontSize: 16 }} className={"m-color-white"} size="large" type="link">
                                <Link to="/main/evaluacionOptima"><ScheduleOutlined /> </Link>
                            </Button>
                        </Popover>

                        <Popover content={'Evaluacion Garantias'} trigger="hover" placement="left">
                            <Button style={{ fontSize: 16 }} className={"m-color-white"} size="large" type="link">
                                <Link to="/main/evaluacionGarantias"><EditOutlined /> </Link>
                            </Button>
                        </Popover>

                    </div>

                    <div>
                        <Button style={{ fontSize: 16 }} className="m-color-white" size="large" type="link">
                            <SettingOutlined />
                        </Button>
                        <Button style={{ fontSize: 16 }} className="m-color-white" size="large" type="link">
                            <UserOutlined />
                        </Button>
                    </div>
                </div>
            </Sider>

            <Content>
                <div>
                    <Switch>
                        <Route path="/test_chart/YearStatistics"  component={YearStatistics} />
                        <Route path="/test_chart/MonthStatistics" component={MonthStatistics} />
                        <Route path="/test_chart/DayStatistics" component={DayStatistics} />
                    </Switch>
                </div>
            </Content>

        </Layout>

    )

}
export default charts